import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { DateTableCell } from '@smx-ui-table/cells/date-table-cell';
import { FORMAT_DATE_TIME } from '@smx-ui-table/const';
import { memo } from 'react';

import { drawingSetFragment$key } from '../graphql/__generated__/drawingSetFragment.graphql';
import { drawingSetVersionFragment$key } from '../graphql/__generated__/drawingSetVersionFragment.graphql';

interface DrawingSetVersionSelectOptionProps {
    node: drawingSetFragment$key;
}

export const DrawingSetVersionSelectOption = ({ node }: DrawingSetVersionSelectOptionProps) => {
    const dataEntity = useFragmentFromStore<drawingSetVersionFragment$key>(node);

    return (
        <>
            <DateTableCell value={dataEntity.versionDate} format={FORMAT_DATE_TIME} />
            {dataEntity.status !== 'PUBLISHED' ? (
                <span style={{ fontWeight: 'bold', marginLeft: 5 }}>(draft)</span>
            ) : (
                ''
            )}
        </>
    );
};

export default memo(DrawingSetVersionSelectOption);
